var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRouteDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_559_13003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.9 0.87739 0 1.94976 0H16.9141L25.9903 9.28V30C25.9903 31.1 25.1129 32 24.0405 32H1.94976C0.87739 32 0 31.1 0 30V2Z",
    fill: "#5AD6A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9044 0V8.26C16.9044 8.81 17.3431 9.26 17.8793 9.26H25.9903",
    fill: "#99EDC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5118 13H6V15.38H19.5118V13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5118 21.62H6V24H19.5118V21.62Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_559_13003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRouteDownload);
export default __webpack_public_path__ + "static/media/ic_route_download.019c544b8a8a48bc51e4d2ae9ab8020a.svg";
export { ForwardRef as ReactComponent };